import type { Appointment, User } from '@/types'

/** Mirrors the API's approval/rejection ownership requirement. */
export function canDecideAppointment(user: User | null, appointment: Appointment): boolean {
  return !!user && (['admin', 'super_admin'].includes(user.role)
    || (user.role === 'doctor' && appointment.doctor_id === user.id))
}
